var ubian = ubian || {};
/**
 * account related methods
 * @type Object
 */
ubian.account = {};

/**
 * mark selected payment card for removal
 * @param {Int} id
 * @returns {undefined}
 */
ubian.account.removePaymentCard = function (id) {

    ubian.utils.confirmDialog(ubian.translate("User.Profile.PaymentCard.RemoveQuestion"),"",ubian.translate("Navigation.Button.Favourite.Yes"), function(){
        $.post(ubian.routes["user_remove_payment_card"], {cardId: id}, function(response){
            $('.js-remove-payment-card[data-id=' + id + ']').parents('li').first().fadeOut();
            $('#js-remove-payment-card-' + id).prop('checked', true);
            console.log($(".cards li").length);
            if ($(".cards li").length == 1){
                $(".no-card-info").removeClass("d-none");
            }
        });
       
    }, ubian.translate("Navigation.Button.Favourite.No"));
}



$(function () {
    $('.js-remove-payment-card').click(function () {
        ubian.account.removePaymentCard($(this).data('id'));
        return false;
    });
    // quickly validate form before submitting
    $('#js-profile-edit-form').submit(function () {
        var password1 = $('#password1').val();
        var password2 = $('#password2').val();
        if (password1 !== password2) {
            ubian.utils.alert(ubian.translate('User.Error.PasswordMismatch'));
            return false;
        }
        if (password1.length > 0) {
            if (password1.length > 0 && password1.length < 6) {
                ubian.utils.alert(ubian.translate('User.Error.PasswordShort'));
                return false;
            }
            if (!__ubian_password_regex.test(password1)) {
                ubian.utils.alert(ubian.translate('User.Error.PasswordFormat'));
                return false;
            }
        }

        return true;
    });
});